import angular from 'angular'
import { dashboardConfig } from './dashboard-config'
import { valueReportingRouteConfig } from './value-reporting-route-config'
import { Agent } from '../../../components/add-agent/index'
import { isEmpty } from '../../../util'
import { datadogRum } from '@datadog/browser-rum'

const app = angular.module('app', [
  'ngRoute',
  'ngAnimate',
  'ngCookies',
  'ngSanitize',
  'route-segment',
  'view-segment',
  'ui.bootstrap',
  'route-segment',
  'view-segment',
  'ui.bootstrap',
  'angularMoment',
  'dialogs.main',
  'pascalprecht.translate',
  'ui.select',
  'feature-flags',
  'cgBusy',
  'infinite-scroll',
  'toastr',
  'sticky',
  'ui.knob',
  'ngFileSaver',
  'angular-ladda',
  'ngclipboard',
  'angular-bind-html-compile',
  'monospaced.elastic',

  'contrast.ui-select',
  'app.ui.directives.typeahead',

  'contrast.auth',
  'contrast.tsv',

  'contrast.filters',
  'contrast.constants',
  'contrast.roles.constants',

  // Factories
  'contrast.factory.agent',
  'contrast.factory.alert',
  'contrast.factory.applications',
  'contrast.factory.application.scores',
  'contrast.factory.application.trends',
  'contrast.factory.attack',
  'contrast.factory.attack.event',
  'contrast.factory.attack.monitor',
  'contrast.factory.common',
  'contrast.factory.contrast.license',
  'contrast.factory.events',
  'contrast.factory.library',
  'contrast.factory.login',
  'contrast.factory.message',
  'contrast.factory.module',
  'contrast.factory.organization',
  'contrast.factory.organization.alert',
  'contrast.factory.password',
  'contrast.factory.profile',
  'contrast.factory.protection.rules',
  'contrast.factory.report',
  'contrast.factory.role',
  'contrast.factory.rule',
  'contrast.factory.score',
  'contrast.factory.search',
  'contrast.factory.security',
  'contrast.factory.sso',
  'contrast.factory.user',
  'contrast.factory.user.rasp',
  'contrast.factory.user.serverless',

  // Services
  'contrast.services.alert',
  'contrast.services.applications.libraries.stats',
  'contrast.services.auth.config',
  'contrast.services.attack',
  'contrast.services.attack.monitor',
  'contrast.services.blockingmodal',
  'contrast.services.organization',
  'contrast.services.organization.attacksearch',
  'contrast.services.password',
  'contrast.services.passwordmeter',
  'contrast.services.progressbar',
  'contrast.services.report',
  'contrast.services.rule',
  'contrast.services.search',
  'contrast.services.security',
  'contrast.services.send.bugtrackers',
  'contrast.services.saml',
  'contrast.services.time',
  'contrast.services.user',
  'contrast.service.keys.management',
  'contrast.services.user.keys',
  'contrast.services.key.status',

  'contrast.services.rules.exclusion',
  'contrast.services.filter',
  'contrast.services.charts',
  'contrast.services.trends',

  // Controllers
  'contrast.applications',
  'contrast.applications.modals',

  'contrast.application.dashboard',
  'contrast.attacks',
  'contrast.attacks.attack',
  'contrast.attacks.monitor',
  'contrast.chart',
  'contrast.chart.util',
  'contrast.constants',
  'contrast.libraries',
  'contrast.newuser',
  'contrast.organization.restore',
  'contrast.reports',
  'contrast.rules',
  'contrast.rules.cve',
  'contrast.rules.exclusions',
  'contrast.score',
  'contrast.settings.audit',
  'contrast.settings.expired.password',
  'contrast.settings.groups',
  'contrast.settings.ip',
  'contrast.settings.password',
  'contrast.settings.permission',
  'contrast.settings.profile',
  'contrast.settings.report',
  'contrast.server.settings',
  'contrast.settings.user.tsv',
  'contrast.attacks.monitor',
  'contrast.tooltips',
  'contrast.tsv.onboard',
  'contrast.modal-rotate-key',

  // Animations
  'contrast.animations',

  // Directives
  'contrast.directives.navselect',
  'contrast.directives.quickfilters',

  // Components
  'contrast.application.coverage',
  'contrast.common',
  'contrast.donut',
  'contrast.grid',
  'contrast.errors',
  'contrast.version',
  'contrast.permissions',
  'contrast.survey',
  'contrast.preferences',
  'contrast.available-languages',
  'contrast.agent-languages',
  'contrast.utils',
  'contrast.score-settings',
  'contrast.score-settings.all-option',
  'contrast.application',
  'contrast.application.protection',
  'contrast.application.assess',
  'contrast.modal-protect-apps-tip',
  'contrast.library.policy',
  'contrast.license',
  'contrast.history',
  'contrast.navigation.history',
  'contrast.beta-rules',
  'contrast.beta-cve-shields',
  'contrast.stats',
  'contrast.label',
  'contrast.server',
  'contrast.current-server',
  'contrast.current-application',
  'contrast.servers',
  'contrast.servers.syslog',
  'contrast.server.vulnerabilities',
  'contrast.d3',
  'contrast.vendors',
  'contrast.flot',
  'contrast.empty-state',
  'contrast.discussion',
  'contrast.loading',
  'contrast.filtering',
  'contrast.features',
  'contrast.icons',
  'contrast.date',
  'contrast.presence',
  'contrast.search',
  'contrast.templates',
  'contrast.virtual-patch',
  'contrast.vulnerabilities',
  'contrast.vulnerabilities.discussion',
  'contrast.vulnerabilities.trend',
  'contrast.vulnerabilities.violations',
  'contrast.cve',
  'contrast.breadcrumbs-nav',
  'contrast.notifications',
  'contrast.notifications.users',
  'contrast.notifications.settings.user',
  'contrast.notifications.settings.org',
  'contrast.login',
  'contrast.timeline',
  'contrast.wizard',
  'contrast.wizard.steps',
  'contrast.get_started',
  'contrast.reset-apps',
  'contrast.sliding-nav',
  'contrast.thermometer-filter',
  'contrast.avatar',
  'contrast.tags',
  'contrast.org-stats',
  'contrast.time-series',
  'contrast.licenses-activity-series',
  'contrast.reports.filter',
  'contrast.protection',
  'contrast.protection.coverage',
  'contrast.empty-row',
  'contrast.integrations',
  'contrast.profile',
  'contrast.ip',
  'contrast.app',
  'contrast.log-enhancer',
  'contrast.technology',
  'contrast.remediation-policy',
  'contrast.panel-headings',
  'contrast.modal',
  'contrast.compliance-policy',
  'contrast.compliance-report',
  'contrast.org.permissions',
  'contrast.app-environment',
  'contrast.tutorial',
  'contrast.application-libraries',
  'contrast.unsaved-changes',
  'contrast.sso',
  'contrast.applications-archive',
  'contrast.grid-action-menu',
  'contrast.flex-grid',
  'contrast.organization-info',
  'contrast.application.vulnerabilities',
  'contrast.toast',
  'contrast.password',
  'contrast.bar-chart',
  'contrast.security-controls',
  'contrast.charts',
  'contrast.metric',
  'contrast.org.vulnerabilities',
  'contrast.org.dashboard',
  'contrast.protect.rules',
  'contrast.org.trace.events',
  'contrast.user.settings',
  'contrast.analytics',
  'contrast.google-analytics',
  'contrast.org.current-trace',
  'contrast.freemium.registration',
  'contrast.freemium',
  'contrast.highcharts',
  'contrast.pendo',
  'contrast.freemium.directives',
  'contrast.languages',

  // Shared Components
  'contrast.shared.groups',
  'contrast.ui',
  'contrast.validation',
  'contrast.thermometer',
  'contrast.form',
  'contrast.browser',
  'contrast.typography',
  'contrast.trace.events',
  'contrast.ui.dev',
  'contrast.badge',
  'contrast.security',
  'contrast.syntax-highlighting',
  'contrast.users',
  'contrast.files',
  'contrast.onboarding.tutorial',
  'contrast.onboarding.setup',

  // Webpack Built Modules
  'react',
  'contrast.react.org'
])

app.constant('CONTRAST_UI_KEY', 'contrast_ui_key')
app.constant('CONTRAST_CSRF_TOKEN', 'X-XSRF-TOKEN')
app.constant('CONTRAST_GRID_COOKIE', 'contrast_grid_toggle')
app.constant('CONTRAST_LIB_GRID_COOKIE', 'contrast_lib_grid_toggle')
app.constant('CONTRAST_CSRF_COOKIE', 'XSRF-TOKEN')
app.constant('PORTAL_TYPE', 'org')
app.constant('GRID_TOGGLED_EVENT', 'gridToggled')

app.value('cgBusyDefaults', {
  message: 'Working...',
  templateUrl: 'views/common/loading.html',
  delay: 0,
  minDuration: 500
})

app.config(
  (
    $routeSegmentProvider,
    $routeProvider,
    $locationProvider,
    AuthOptionsProvider
  ) => {
    'ngInject'
    $locationProvider.hashPrefix('')
    $routeSegmentProvider.options.autoLoadTemplates = true

    const publicRoutes = [
      'pages/signin',
      'pages/forgot-password',
      'pages/expired',
      'pages/logout'
    ]
    publicRoutes.forEach((route) => {
      $routeSegmentProvider
        .when('/' + route, route)
        .segment(route, {
          templateUrl: 'views/' + route + '.html'
        })
        .up()
    })

    const tsvRoutes = [
      'tsv/verification',
      'tsv/signin',
      'tsv/backup-code',
      'tsv/setup'
    ]
    tsvRoutes.forEach((route) => {
      $routeSegmentProvider
        .when('/' + route, route)
        .segment(route, {
          templateUrl: 'views/' + route + '.html'
        })
        .up()
    })

    const errorRoutes = [
      'pages/400',
      'pages/401',
      'pages/403',
      'pages/404',
      'pages/405',
      'pages/500',
      'pages/503'
    ]
    errorRoutes.forEach((route) => {
      $routeSegmentProvider
        .when('/' + route, route)
        .segment(route, {
          templateUrl: 'views/' + route + '.html',
          controller: 'ErrorCtrl',
          resolve: {
            home: () => {
              return 'dashboard'
            }
          }
        })
        .up()
    })

    const routes = ['pages/expired-password']
    // secured routes
    routes.forEach((route) => {
      $routeSegmentProvider
        .when('/' + route, route)
        .segment(
          route,
          AuthOptionsProvider.buildSecureRouteConfiguration(
            'views/' + route + '.html'
          )
        )
        .up()
    })

    $routeProvider.otherwise({
      redirectTo: (_, path) => (path === '' ? 'pages/signin' : 'pages/404')
    })
  }
)

// password reset routes
app.config(($routeSegmentProvider, $locationProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment('updatePassword', {
    templateUrl: 'views/pages/update-password.html',
    dependencies: ['email', 'token'],
    controller: 'PasswordUpdateCtrl',
    resolve: {
      policy: ($routeParams, CommonFactory) => {
        'ngInject'

        const user = $routeParams.email
        const token = $routeParams.token
        return CommonFactory.getResetPolicy(user, token).then(
          (response) => response.data.policy
        )
      }
    },
    resolveFailed: {
      templateUrl: 'views/pages/signin.html',
      controller: ($location, logger) => {
        'ngInject'

        logger.logError('Invalid Request')
        $location.path('/pages/signin', true).search('unauthenticated', 'true')
      }
    }
  })

  $routeSegmentProvider.when(
    '/pages/update-password/:email/:token',
    'updatePassword'
  )
})

// freemium routes
app.config(($routeSegmentProvider, $locationProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment('freemiumActivation', {
    templateUrl: 'views/freemium/password.html',
    controller: 'FreemiumActivationCtrl',
    dependencies: ['freemiumToken'],
    resolve: {
      policy: (
        $routeParams,
        $location,
        logger,
        freemiumRegistrationService
      ) => {
        'ngInject'

        return freemiumRegistrationService
          .validate($routeParams.freemiumToken)
          .then((response) => {
            if (response.status === 201) {
              logger.logSuccess(response.data.messages[0])
              $location.path('/pages/signin', true)
              return
            } else {
              return response.data.policy
            }
          })
      }
    },
    resolveFailed: {
      templateUrl: 'views/pages/signin.html',
      controller: ($location, logger) => {
        'ngInject'

        logger.logError('Invalid Request')
        $location.path('/pages/signin', true).search('unauthenticated', 'true')
      }
    }
  })

  $routeSegmentProvider.when(
    '/freemium/activation/:freemiumToken',
    'freemiumActivation'
  )
})

// free-trial routes

app.config(($routeSegmentProvider, $locationProvider) => {
  'ngInject'
  $locationProvider.hashPrefix('')
  $routeSegmentProvider.options.autoLoadTemplates = true
  $routeSegmentProvider
    .when('/free-trial/activation/:freeTrailToken', 'freeTrialActivation')
    .segment('freeTrialActivation', {
      templateUrl: 'views/free-trial/password.html'
    })
    .up()
})

// dashboard routes
app.config(dashboardConfig)

// register new user
app.config(($routeSegmentProvider, $locationProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment('register', {
    templateUrl: 'views/pages/register.html',
    dependencies: ['email', 'token'],
    controller: 'RegisterCtrl',
    resolve: {
      policy: ($routeParams, CommonFactory) => {
        'ngInject'

        const user = $routeParams.email
        const token = $routeParams.token
        return CommonFactory.getRegistrationPolicy(user, token).then(
          (response) => response.data.policy
        )
      }
    },
    resolveFailed: {
      templateUrl: 'views/pages/signin.html',
      controller: ($location, logger) => {
        'ngInject'

        logger.logError('Invalid Request')
        $location.path('/pages/signin', true).search('unauthenticated', 'true')
      }
    }
  })

  $routeSegmentProvider.when('/pages/register/:email/:token', 'register')
})

// servers routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'servers',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/servers/servers.html'
    ),
    false,
    ['orgUuid']
  )

  $routeSegmentProvider.segment(
    'serverDashboard',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/servers/dashboard.html',
      false,
      ['orgUuid', 'serverId']
    )
  )
  $routeSegmentProvider
    .within('serverDashboard')
    .segment(
      'overview',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/servers/overview.html',
        true
      )
    )
  $routeSegmentProvider
    .within('serverDashboard')
    .segment(
      'libraries',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/libraries-server-new.html',
        false
      )
    )
  $routeSegmentProvider
    .within('serverDashboard')
    .segment(
      'attacks',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/attacks/attacks.html',
        false
      )
    )
  $routeSegmentProvider
    .within('serverDashboard')
    .segment(
      'notes',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/servers/notes.html',
        false
      )
    )

  $routeSegmentProvider
    .within('serverDashboard')
    .segment(
      'vulns',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/servers/vulns.html',
        false
      )
    )

  $routeSegmentProvider
    .within('serverDashboard')
    .segment(
      'vuln',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'components-org/vulnerabilities/overview-nested.html',
        'ServerVulnOverviewCtrl',
        false,
        ['uuid']
      )
    )
  $routeSegmentProvider
    .within('serverDashboard')
    .within('vuln')
    .segment(
      'summary',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/summary.html',
        true
      )
    )
  $routeSegmentProvider
    .within('serverDashboard')
    .within('vuln')
    .segment(
      'recommendation',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/recommendation.html',
        false
      )
    )
  $routeSegmentProvider
    .within('serverDashboard')
    .within('vuln')
    .segment(
      'request',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/request.html',
        false
      )
    )
  $routeSegmentProvider
    .within('serverDashboard')
    .within('vuln')
    .segment(
      'events',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/events.html',
        false
      )
    )
  $routeSegmentProvider
    .within('serverDashboard')
    .within('vuln')
    .segment(
      'notes',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/notes.html',
        false
      )
    )
  $routeSegmentProvider
    .within('serverDashboard')
    .within('vuln')
    .segment(
      'discussion',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/discussion.html',
        false
      )
    )
  $routeSegmentProvider
    .within('serverDashboard')
    .segment(
      'unauthorized',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'components-org/vulnerabilities/unauthorized.html',
        'ServerVulnUnauthorizedCtrl',
        false,
        ['uuid']
      )
    )

  $routeSegmentProvider
    .when('/:orgUuid/servers', 'servers')
    .when('/:orgUuid/servers/:serverId/overview', 'serverDashboard.overview')
    .when('/:orgUuid/servers/:serverId/attacks', 'serverDashboard.attacks')
    .when('/:orgUuid/servers/:serverId/libraries', 'serverDashboard.libraries')
    .when('/:orgUuid/servers/:serverId/vulns', 'serverDashboard.vulns')
    .when('/:orgUuid/servers/:serverId/notes', 'serverDashboard.notes')
    .when('/:orgUuid/servers/:serverId/vulns/:uuid', 'serverDashboard.vuln')
    .when(
      '/:orgUuid/servers/:serverId/vulns/:uuid/summary',
      'serverDashboard.vuln.summary'
    )
    .when(
      '/:orgUuid/servers/:serverId/vulns/:uuid/recommendation',
      'serverDashboard.vuln.recommendation'
    )
    .when(
      '/:orgUuid/servers/:serverId/vulns/:uuid/request',
      'serverDashboard.vuln.request'
    )
    .when(
      '/:orgUuid/servers/:serverId/vulns/:uuid/events',
      'serverDashboard.vuln.events'
    )
    .when(
      '/:orgUuid/servers/:serverId/vulns/:uuid/notes',
      'serverDashboard.vuln.notes'
    )
    .when(
      '/:orgUuid/servers/:serverId/vulns/:uuid/discussion',
      'serverDashboard.vuln.discussion'
    )
    .when(
      '/:orgUuid/servers/:serverId/vulns/:uuid/unauthorized',
      'serverDashboard.unauthorized'
    )
})

// deployment-hub
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'deployment-hub',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/app-config-page.html',
      false,
      ['orgUuid']
    )
  )
  $routeSegmentProvider
    .when('/:orgUuid/deployment-hub/:anything*?', 'deployment-hub')
    .when('/:orgUuid/deployment-hub', 'deployment-hub')
})

// libraries routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'libraries',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/libraries-new.html',
      false,
      ['orgUuid']
    )
  )
  $routeSegmentProvider.segment(
    'libraryViolation',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/libraries-new.html',
      false,
      ['orgUuid']
    )
  )
  $routeSegmentProvider.segment(
    'libraryDashboard',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/libraries/dashboard.html',
      false,
      ['orgUuid', 'libraryId', 'language']
    )
  )
  $routeSegmentProvider
    .within('libraryDashboard')
    .segment(
      'overview',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/libraries/overview.html',
        true
      )
    )

  $routeSegmentProvider
    .when('/:orgUuid/libraries/static', 'libraries')
    .when('/:orgUuid/libraries', 'libraries')
    .when('/:orgUuid/libraries/violation', 'libraryViolation')
    .when(
      '/:orgUuid/libraries/:language/:libraryId',
      'libraryDashboard.overview'
    )
})

// applications library drilldown route
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'appLibDrilldown',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/libraries/drilldown.html',
      false,
      ['orgUuid', 'appId', 'language', 'libraryId']
    )
  )
  $routeSegmentProvider.segment(
    'appLibraryDashboard',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/libraries/dashboard.html',
      false,
      ['orgUuid', 'appId', 'libraryId', 'language']
    )
  )
  $routeSegmentProvider
    .within('appLibraryDashboard')
    .segment(
      'overview',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/libraries/overview.html',
        true
      )
    )

  $routeSegmentProvider
    .when(
      '/:orgUuid/applications/:appId/libs/:language/:libraryId/old',
      'appLibDrilldown'
    )
    .when(
      '/:orgUuid/applications/:appId/libs/:language/:libraryId',
      'appLibraryDashboard.overview'
    )
})

// server library drilldown route
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'serverLibDrilldown',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/libraries/drilldown.html',
      false,
      ['orgUuid', 'serverId', 'language', 'libraryId']
    )
  )
  $routeSegmentProvider.segment(
    'serverLibraryDashboard',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/libraries/dashboard.html',
      false,
      ['orgUuid', 'libraryId', 'language']
    )
  )
  $routeSegmentProvider
    .within('serverLibraryDashboard')
    .segment(
      'overview',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/libraries/overview.html',
        true
      )
    )

  $routeSegmentProvider
    .when(
      '/:orgUuid/servers/:serverId/libs/:language/:libraryId/old',
      'serverLibDrilldown'
    )
    .when(
      '/:orgUuid/servers/:serverId/libs/:language/:libraryId',
      'serverLibraryDashboard.overview'
    )
})

// value reporting route
app.config(valueReportingRouteConfig)

// applications and app dashboard routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'applications',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/applications.html',
      false,
      ['orgUuid']
    )
  )

  $routeSegmentProvider.segment(
    'appDashboard',
    AuthOptionsProvider.buildSecureRouteConfigurationWithController(
      'views/applications/dashboard.html',
      'ApplicationDashboardCtrl',
      false,
      ['appId']
    )
  )

  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'overview',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/applications/overview.html',
        true
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'observe',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/applications/observe.html',
        true
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'flow_map',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/applications/flow-map.html',
        true
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'libs',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/libraries-app-new.html',
        true
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'depTree',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/applications/dependency-tree.html',
        true
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'libsNew',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/libraries-app-new.html',
        true
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'coverage',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/applications/coverage.html',
        'AppCoverageCtrl',
        true
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'attacks',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/attacks/attacks.html',
        true
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'attacks_all',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/applications/attacks.html',
        true
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'vulns',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/applications/vulns.html',
        false
      )
    )

  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'vulns_policy',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/applications/vulns.html',
        false
      )
    )

  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'vuln',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'components-org/vulnerabilities/overview-nested.html',
        'AppVulnOverviewCtrl',
        false,
        ['uuid']
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .within('vuln')
    .segment(
      'summary',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/summary.html',
        true
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .within('vuln')
    .segment(
      'recommendation',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/recommendation.html',
        false
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .within('vuln')
    .segment(
      'request',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/request.html',
        false
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .within('vuln')
    .segment(
      'events',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/events.html',
        false
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .within('vuln')
    .segment(
      'notes',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/notes.html',
        false
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .within('vuln')
    .segment(
      'discussion',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/discussion.html',
        false
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'unauthorized',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'components-org/vulnerabilities/unauthorized.html',
        'AppVulnUnauthorizedCtrl',
        false,
        ['uuid']
      )
    )

  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'exclusions',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/applications/settings/exclusions.html',
        'AppSettingsRuleExclusionsCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'protection',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/applications/settings/protection.html',
        'AppProtectionCtrl',
        false,
        ['appId']
      )
    )
  $routeSegmentProvider.within('appDashboard').segment(
    'assess',
    AuthOptionsProvider.buildSecureRouteConfigurationWithController(
      'views/applications/settings/assess.html',
      // uncomment to enable app policy grid react migration (in progress)
      // 'views/applications/settings/assess-react.html',
      'AppAssessCtrl',
      false,
      ['appId']
    )
  )
  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'protection_rule',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/applications/settings/protection.html',
        'AppProtectionCtrl',
        false,
        ['appId', 'protectionRuleId']
      )
    )
  $routeSegmentProvider
    .within('appDashboard')
    .segment(
      'routeCoverage',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/applications/route-coverage.html',
        false
      )
    )

  $routeSegmentProvider
    .when('/:orgUuid/applications/:appId', 'appDashboard.overview')
    .when('/:orgUuid/applications/:appId/observe', 'appDashboard.observe')
    .when('/:orgUuid/applications/:appId/flow-map', 'appDashboard.flow_map')
    .when('/:orgUuid/applications/:appId/reports', 'appDashboard.reports')
    .when('/:orgUuid/applications/:appId/vulns', 'appDashboard.vulns')
    .when(
      '/:orgUuid/applications/:appId/vulns/policy',
      'appDashboard.vulns_policy'
    )
    .when('/:orgUuid/applications/:appId/vulns/:uuid', 'appDashboard.vuln')
    .when(
      '/:orgUuid/applications/:appId/vulns/:uuid/summary',
      'appDashboard.vuln.summary'
    )
    .when(
      '/:orgUuid/applications/:appId/vulns/:uuid/recommendation',
      'appDashboard.vuln.recommendation'
    )
    .when(
      '/:orgUuid/applications/:appId/vulns/:uuid/request',
      'appDashboard.vuln.request'
    )
    .when(
      '/:orgUuid/applications/:appId/vulns/:uuid/events',
      'appDashboard.vuln.events'
    )
    .when(
      '/:orgUuid/applications/:appId/vulns/:uuid/notes',
      'appDashboard.vuln.notes'
    )
    .when(
      '/:orgUuid/applications/:appId/vulns/:uuid/discussion',
      'appDashboard.vuln.discussion'
    )
    .when(
      '/:orgUuid/applications/:appId/vulns/:uuid/unauthorized',
      'appDashboard.unauthorized'
    )
    .when('/:orgUuid/applications/:appId/libs', 'appDashboard.libs')
    .when(
      '/:orgUuid/applications/:appId/libs/dependency-tree',
      'appDashboard.depTree'
    )
    .when('/:orgUuid/applications/:appId/coverage', 'appDashboard.coverage')
    .when('/:orgUuid/applications/:appId/settings', 'appDashboard.settings')
    .when('/:orgUuid/applications/:appId/attacks', 'appDashboard.attacks')
    .when(
      '/:orgUuid/applications/:appId/attacks/all',
      'appDashboard.attacks_all'
    )
    .when('/:orgUuid/applications/:appId/exclusions', 'appDashboard.exclusions')
    .when('/:orgUuid/applications/:appId/protection', 'appDashboard.protection')
    .when('/:orgUuid/applications/:appId/assess', 'appDashboard.assess')
    .when(
      '/:orgUuid/applications/:appId/route-coverage',
      'appDashboard.routeCoverage'
    )
    .when(
      '/:orgUuid/applications/:appId/protection/:protectionRuleId',
      'appDashboard.protection_rule'
    )
    .when('/:orgUuid/applications/quickfilter/:quickfilter', 'applications')
    .when('/:orgUuid/applications', 'applications')
})

// scans applications routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'scans',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/scans.html',
      false,
      ['orgUuid']
    )
  )

  $routeSegmentProvider
    .when('/:orgUuid/scans/:anything*?', 'scans')
    .when('/:orgUuid/scans', 'scans')
})

// Add new sensor routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'select-sensor-wizard',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/select-sensor-wizard.html',
      false,
      ['orgUuid']
    )
  )

  $routeSegmentProvider.when(
    '/:orgUuid/select-sensor-wizard',
    'select-sensor-wizard'
  )
})

// repository routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'projects',
    AuthOptionsProvider.buildSecureRouteConfiguration('views/projects.html'),
    false,
    ['orgUuid']
  )
  $routeSegmentProvider.when('/:orgUuid/projects', 'projects')
})

// serverless application routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'serverless',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/serverless.html',
      false,
      ['orgUuid']
    )
  )

  $routeSegmentProvider
    .when('/:orgUuid/serverless', 'serverless')
    .when('/:orgUuid/serverless/:serverless*?', 'serverless')
    .when('/:orgUuid/serverless/accounts/:accountId', 'serverless.account')
})

// containers (serverless) application routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'containers',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/containers.html',
      false,
      ['orgUuid']
    )
  )

  $routeSegmentProvider
    .when('/:orgUuid/containers', 'containers')
    .when('/:orgUuid/containers/:containers*?', 'containers')
    .when('/:orgUuid/containers/registries/:registryId', 'containers.registry')
})

app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'uiDevIcons',
    AuthOptionsProvider.buildSecureRouteConfigurationWithParams({
      templateUrl: 'components/ui-dev/icons.html',
      controller: 'UiDevIconsCtrl',
      controllerAs: 'vm'
    })
  )

  $routeSegmentProvider.when('/:orgUuid/ui-dev/icons', 'uiDevIcons')
})

// reports routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'reports',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'components-org/reports/reports.html',
      false,
      ['orgUuid']
    )
  )
  $routeSegmentProvider.segment(
    'reports_view',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/reports/view.html',
      false,
      ['orgUuid']
    )
  )
  $routeSegmentProvider.segment(
    'reports_org_stats_drilldown',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/org-stats/drilldown.html',
      false,
      ['orgUuid']
    )
  )
  $routeSegmentProvider
    .within('reports_org_stats_drilldown')
    .segment(
      'licenses',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/org-stats/licenses.html',
        true
      )
    )
  $routeSegmentProvider
    .within('reports_org_stats_drilldown')
    .segment(
      'apps',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/org-stats/apps.html'
      )
    )
  $routeSegmentProvider
    .within('reports_org_stats_drilldown')
    .segment(
      'servers',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/org-stats/servers.html'
      )
    )

  $routeSegmentProvider
    .when('/:orgUuid/reports', 'reports')
    .when('/:orgUuid/reports/view', 'reports_view')
    .when('/:orgUuid/reports/stats', 'reports_org_stats_drilldown')
    .when(
      '/:orgUuid/reports/stats/licenses',
      'reports_org_stats_drilldown.licenses'
    )
    .when(
      '/:orgUuid/reports/stats/applications',
      'reports_org_stats_drilldown.apps'
    )
    .when(
      '/:orgUuid/reports/stats/servers',
      'reports_org_stats_drilldown.servers'
    )
})

// report dashboard routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'report-dashboard',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/report-dashboard.html',
      false,
      ['orgUuid']
    )
  )

  $routeSegmentProvider.when('/:orgUuid/report-dashboard', 'report-dashboard')
})

// setup routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'account',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/account.html',
      false,
      ['orgUuid']
    )
  )
  $routeSegmentProvider
    .within('account')
    .segment(
      'profile',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/account/profile.html',
        true
      )
    )
  $routeSegmentProvider
    .within('account')
    .segment(
      'password',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/account/change_password.html'
      )
    )
  $routeSegmentProvider
    .within('account')
    .segment(
      'permissions',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/account/permissions.html'
      )
    )
  $routeSegmentProvider
    .within('account')
    .segment(
      'tsv',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/account/tsv.html'
      )
    )
  $routeSegmentProvider
    .within('account')
    .segment(
      'notifications',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components-org/notifications/user-notifications.html'
      )
    )
  $routeSegmentProvider
    .within('account')
    .segment(
      'security-settings',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/account/security-settings.html'
      )
    )

  $routeSegmentProvider
    .when('/:orgUuid/account', 'account')
    .when('/:orgUuid/account/profile', 'account.profile')
    .when('/:orgUuid/account/password', 'account.password')
    .when('/:orgUuid/account/permissions', 'account.permissions')
    .when('/:orgUuid/account/tsv', 'account.tsv')
    .when('/:orgUuid/account/notifications', 'account.notifications')
    .when('/:orgUuid/account/security-settings', 'account.security-settings')
})

// setup routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'settings',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/settings.html',
      false,
      ['orgUuid']
    )
  )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'organization',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/settings.html',
        true
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'organization-view',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/organization-view.html',
        undefined,
        undefined
      )
    )

  $routeSegmentProvider
    .within('settings')
    .segment(
      'integration',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations.html',
        'IntegrationCtrl',
        false
      )
    )
  // TODO: Remove this route when all conversion to react is done
  $routeSegmentProvider
    .within('settings')
    .segment(
      'integration_react',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations-react.html',
        'IntegrationCtrl',
        false
      )
    )

  $routeSegmentProvider
    .within('settings')
    .segment(
      'webhook_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/webhook.html',
        'WebhookCreateCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'webhook_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/webhook.html',
        'WebhookEditCtrl',
        false,
        ['webhookId']
      )
    )

  $routeSegmentProvider
    .within('settings')
    .segment(
      'slack_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/slack.html',
        'SlackCreateCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'slack_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/slack.html',
        'SlackEditCtrl',
        false,
        ['slackId']
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'microsoftteams_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/microsoftteams.html',
        'MicrosoftteamsCreateCtrl',
        false
      )
    )
  $routeSegmentProvider.within('settings').segment(
    'microsoftteams_edit',
    AuthOptionsProvider.buildSecureRouteConfigurationWithController(
      'views/settings/integrations/microsoftteams.html',
      'MicrosoftteamsEditCtrl',
      false,

      ['microsoftteamsId']
    )
  )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'victorops_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/victorops.html',
        'VictorOpsCreateCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'victorops_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/victorops.html',
        'VictorOpsEditCtrl',
        false,
        ['victorOpsId']
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'pagerduty_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/pagerduty.html',
        'PagerDutyCreateCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'pagerduty_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/pagerduty.html',
        'PagerDutyEditCtrl',
        false,
        ['pagerDutyId']
      )
    )
  $routeSegmentProvider.within('settings').segment(
    'jira_add',
    AuthOptionsProvider.buildSecureRouteConfigurationWithParams({
      template:
        '<react-jira-integration-page current-organization="bridgeApi.getCurrentOrganization()"></react-jira-integration-page>',
      isDefault: false
    })
  )
  $routeSegmentProvider.within('settings').segment(
    'jira_edit',
    AuthOptionsProvider.buildSecureRouteConfigurationWithParams({
      template:
        '<react-jira-integration-page current-organization="bridgeApi.getCurrentOrganization()"></react-jira-integration-page>',
      isDefault: false,
      dependencies: ['jiraId']
    })
  )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'vsts_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/vsts.html',
        'VSTSIntegrationCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'vsts_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/vsts.html',
        'VSTSIntegrationCtrl',
        false,
        ['vstsId']
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'github_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/github.html',
        'GitHubIntegrationCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'github_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/github.html',
        'GitHubIntegrationCtrl',
        false,
        ['githubId']
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'agile_central_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/agile_central.html',
        'AgileCentralIntegrationCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'agile_central_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/agile_central.html',
        'AgileCentralIntegrationCtrl',
        false,
        ['agileCentralId']
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'credentials_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/bugtracker-credentials.html',
        'BugtrackerCredentialsCtrl',
        false,
        ['bugtracker']
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'jenkins_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/jenkins.html',
        'JenkinsIntegrationCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'jenkins_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/integrations/jenkins.html',
        'JenkinsIntegrationCtrl',
        false,
        ['jenkinsId']
      )
    )

  $routeSegmentProvider
    .within('settings')
    .segment(
      'users',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/users.html',
        false,
        ['orgUuid'],
        { access: canAccessEACUsersPage }
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'users_add',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/users/add.html',
        false,
        ['orgUuid'],
        { access: canAccessEACUsersPage }
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'users_edit',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/users/edit.html',
        false,
        ['orgUuid', 'userUid'],
        { access: canAccessEACUsersPage }
      )
    )

  $routeSegmentProvider
    .within('settings')
    .segment(
      'alerts',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/alerts.html'
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'notifications',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components-org/notifications/notification-organization-settings.html'
      )
    )

  $routeSegmentProvider
    .within('settings')
    .segment(
      'notifications_integration_id',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components-org/notifications/notification-organization-settings.html'
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'sso',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/sso.html'
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'sso_add',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/sso/add.html'
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'api',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/api.html'
      )
    )

  $routeSegmentProvider
    .within('settings')
    .segment(
      'api_agent',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/api.html'
      )
    )

  $routeSegmentProvider
    .within('settings')
    .segment(
      'report',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/report_settings.html'
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'score',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/score_settings.html'
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'access',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/access_settings.html'
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'audit',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/audit_log.html'
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'security',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/security.html'
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'server',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/server_settings.html'
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'application',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/application_settings.html'
      )
    )

  $routeSegmentProvider
    .within('settings')
    .segment(
      'groups',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/group/group.html'
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'groups_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/group/form.html',
        'AddGroupCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('settings')
    .segment(
      'groups_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/settings/group/form.html',
        'EditGroupCtrl',
        false,
        ['groupId']
      )
    )

  $routeSegmentProvider
    .within('settings')
    .within('security')
    .segment(
      'policy',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/security/policy.html'
      )
    )

  $routeSegmentProvider
    .within('settings')
    .within('security')
    .segment(
      'audit',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/security/audit.html'
      )
    )

  $routeSegmentProvider
    .within('settings')
    .segment(
      'scan_projects',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/settings/scan_projects.html'
      )
    )

  $routeSegmentProvider
    .when('/:orgUuid/settings', 'settings')
    .when('/:orgUuid/settings/organization', 'settings.organization')
    .when('/:orgUuid/settings/organization-view', 'settings.organization-view')
    .when('/:orgUuid/settings/groups', 'settings.groups')
    .when('/:orgUuid/settings/groups/add', 'settings.groups_add')
    .when('/:orgUuid/settings/groups/edit/:groupId', 'settings.groups_edit')
    .when('/:orgUuid/settings/users', 'settings.users')
    .when('/:orgUuid/settings/users/add', 'settings.users_add')
    .when('/:orgUuid/settings/users/edit/:userUid', 'settings.users_edit')
    .when('/:orgUuid/settings/security', 'settings.security')
    .when('/:orgUuid/settings/security/policy', 'settings.security.policy')
    .when('/:orgUuid/settings/security/audit', 'settings.security.audit')
    .when('/:orgUuid/settings/alerts', 'settings.alerts')
    .when('/:orgUuid/settings/notifications', 'settings.notifications')
    .when(
      '/:orgUuid/settings/notifications/:integrationId',
      'settings.notifications_integration_id'
    )
    .when('/:orgUuid/settings/integration', 'settings.integration')
    .when('/:orgUuid/settings/integration-react', 'settings.integration_react')
    .when('/:orgUuid/settings/integration/webhook', 'settings.webhook_add')
    .when(
      '/:orgUuid/settings/integration/webhook/:webhookId',
      'settings.webhook_edit'
    )
    .when('/:orgUuid/settings/integration/slack', 'settings.slack_add')
    .when(
      '/:orgUuid/settings/integration/slack/:slackId',
      'settings.slack_edit'
    )
    .when('/:orgUuid/settings/integration/victorops', 'settings.victorops_add')
    .when(
      '/:orgUuid/settings/integration/victorops/:victorOpsId',
      'settings.victorops_edit'
    )
    .when('/:orgUuid/settings/integration/pagerduty', 'settings.pagerduty_add')
    .when(
      '/:orgUuid/settings/integration/pagerduty/:pagerDutyId',
      'settings.pagerduty_edit'
    )
    .when(
      '/:orgUuid/settings/integration/microsoftteams',
      'settings.microsoftteams_add'
    )
    .when(
      '/:orgUuid/settings/integration/microsoftteams/:microsoftteamsId',
      'settings.microsoftteams_edit'
    )
    .when('/:orgUuid/settings/integration/jira', 'settings.jira_add')
    .when('/:orgUuid/settings/integration/jira/:jiraId', 'settings.jira_edit')
    .when('/:orgUuid/settings/integration/vsts', 'settings.vsts_add')
    .when('/:orgUuid/settings/integration/vsts/:vstsId', 'settings.vsts_edit')
    .when('/:orgUuid/settings/integration/github', 'settings.github_add')
    .when('/:orgUuid/settings/integration/jenkins', 'settings.jenkins_add')
    .when(
      '/:orgUuid/settings/integration/jenkins/:jenkinsId',
      'settings.jenkins_edit'
    )
    .when(
      '/:orgUuid/settings/integration/github/:githubId',
      'settings.github_edit'
    )
    .when(
      '/:orgUuid/settings/integration/agilecentral',
      'settings.agile_central_add'
    )
    .when(
      '/:orgUuid/settings/integration/agilecentral/:agileCentralId',
      'settings.agile_central_edit'
    )
    .when(
      '/:orgUuid/settings/integration/credentials/:bugtracker',
      'settings.credentials_edit'
    )
    .when('/:orgUuid/settings/sso', 'settings.sso')
    .when('/:orgUuid/settings/sso/add', 'settings.sso_add')
    .when('/:orgUuid/settings/api', 'settings.api')
    .when('/:orgUuid/settings/api/:agent', 'settings.api_agent')
    .when('/:orgUuid/settings/report', 'settings.report')
    .when('/:orgUuid/settings/server', 'settings.server')
    .when('/:orgUuid/settings/application', 'settings.application')
    .when('/:orgUuid/settings/score', 'settings.score')
    .when('/:orgUuid/settings/access/:anything*?', 'settings.access')
    .when('/:orgUuid/settings/access', 'settings.access')
    .when('/:orgUuid/settings/audit', 'settings.audit')
    .when('/:orgUuid/settings/scan-projects', 'settings.scan-projects')
})

// add agent wizard routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  const options = {
    resolve: {}
  }

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'wizard',
    AuthOptionsProvider.buildSecureRouteConfigurationWithParams(
      Object.assign(options, {
        default: false,
        dependencies: ['orgUuid']
      })
    )
  )

  const stepConfig =
    AuthOptionsProvider.buildSecureRouteConfigurationWithParams(
      Object.assign(options, {
        default: true,
        dependencies: ['agent']
      })
    )

  // PROD-1008: Deprecating wizard views
  // Redirect to 404 page for deprecated wizard views
  const pageNotFound = 'pages/404'
  const deprecatedWizardViewAgents: Agent[] = ['JAVA', 'DOTNET_CORE']
  deprecatedWizardViewAgents.forEach((agent) => {
    const base = '/:orgUuid/wizard'
    $routeSegmentProvider.when(`${base}/restart/${agent}`, pageNotFound)
    $routeSegmentProvider.when(`${base}/configure/${agent}`, pageNotFound)
    $routeSegmentProvider.when(`${base}/connection/${agent}`, pageNotFound)
    $routeSegmentProvider.when(`${base}/running/${agent}`, pageNotFound)
    $routeSegmentProvider.when(`${base}/install/${agent}`, pageNotFound)
  })

  $routeSegmentProvider.within('wizard').segment('download', stepConfig)
  $routeSegmentProvider.within('wizard').segment('install', stepConfig)
  $routeSegmentProvider.within('wizard').segment('restart', stepConfig)
  $routeSegmentProvider.within('wizard').segment('configure', stepConfig)
  $routeSegmentProvider.within('wizard').segment('connection', stepConfig)
  $routeSegmentProvider.within('wizard').segment('running', stepConfig)

  $routeSegmentProvider
    .when('/:orgUuid/wizard', 'wizard')
    .when('/:orgUuid/wizard/download/:agent', 'wizard.download')
    .when('/:orgUuid/wizard/restart/:agent', 'wizard.restart')
    .when('/:orgUuid/wizard/configure/:agent', 'wizard.configure')
    .when('/:orgUuid/wizard/connection/:agent', 'wizard.connection')
    .when('/:orgUuid/wizard/running/:agent', 'wizard.running')
    .when('/:orgUuid/wizard/install/:agent', 'wizard.install')
})

// setup routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'rules',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/rules.html',
      false,
      ['orgUuid']
    )
  )

  // Assess
  $routeSegmentProvider
    .within('rules')
    .segment(
      'manage',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/rules/manage.html',
        'RulesCtrl',
        true
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'manage_default',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/rules/manage_default.html',
        'RulesDefaultCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'manage_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/rules/manage/drilldown.html',
        'EditRuleManageCtrl',
        false,
        ['controlType', 'controlId']
      )
    )

  const securityControlPath = 'components-org/security-controls/'
  $routeSegmentProvider
    .within('rules')
    .segment(
      'controls',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        securityControlPath + 'controls.html'
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'controls_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        securityControlPath + 'drilldown.html',
        'AddRuleControlCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'controls_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        securityControlPath + 'drilldown.html',
        'EditRuleControlCtrl',
        false,
        ['controlId']
      )
    )

  $routeSegmentProvider
    .within('rules')
    .segment(
      'vulnerability_management',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/policy/vulnerability-management/policy.html',
        false,
        ['orgUuid']
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'vulnerability_management_policy_edit',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/policy/vulnerability-management/policy/edit.html',
        false,
        ['orgUuid', 'policyId']
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'vulnerability_management_policy_add',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/policy/vulnerability-management/policy/add.html',
        false,
        ['orgUuid', 'action']
      )
    )

  $routeSegmentProvider
    .within('rules')
    .segment(
      'ip',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/rules/ip/management.html'
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'ip_denylist',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/rules/ip/management.html'
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'ip_allowlist',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/rules/ip/management.html'
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'ip_source_names',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/rules/ip/management.html'
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'ip_source_name_add',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/rules/ip/source-name-add.html'
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'ip_source_name_edit',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/rules/ip/source-name-edit.html',
        false,
        ['sourceNameId']
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'ip_add_denylist',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/rules/ip/create.html'
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'ip_add_denylist_from_attack',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/rules/ip/create.html',
        false,
        ['sourceIp']
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'ip_add_allowlist',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/rules/ip/create.html'
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'ip_edit',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/rules/ip/edit.html',
        false,
        ['addressUuid']
      )
    )

  const virtualPatchPath = 'components/virtual-patch/'
  $routeSegmentProvider
    .within('rules')
    .segment(
      'patch',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        virtualPatchPath + 'management.html'
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'patch_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        virtualPatchPath + 'virtual-patch.html',
        'AddVirtualPatchCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'patch_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        virtualPatchPath + 'virtual-patch.html',
        'EditVirtualPatchCtrl',
        false,
        ['patchUuid']
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'patch_from_event',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        virtualPatchPath + 'virtual-patch.html',
        'PrePopVirtualPatchCtrl',
        false,
        ['eventId']
      )
    )

  const logEnhancerPath = 'components/log-enhancer/'
  $routeSegmentProvider
    .within('rules')
    .segment(
      'log',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        logEnhancerPath + 'log-enhancer.html'
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'log_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        logEnhancerPath + 'log-enhancer-drilldown.html',
        'AddLogEnhancerCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'log_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        logEnhancerPath + 'log-enhancer-drilldown.html',
        'EditLogEnhancerCtrl',
        false,
        ['logId']
      )
    )

  $routeSegmentProvider
    .within('rules')
    .segment(
      'library_policy',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/rules/library/policy.html',
        false
      )
    )

  $routeSegmentProvider
    .within('rules')
    .segment(
      'exclusions',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/rules/exclusions/exclusions.html',
        'ExclusionsCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'exclusions_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/rules/exclusions/edit.html',
        'EditExclusionCtrl',
        false,
        ['appId', 'exclusionId']
      )
    )

  $routeSegmentProvider
    .within('rules')
    .segment(
      'sensitive_data_grid',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/policy/sensitive-data/sensitive_data_grid.html',
        false,
        ['orgUuid']
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'sensitive_data_type_edit',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/policy/sensitive-data/edit_sensitive_data_type_form.html',
        false,
        ['orgUuid', 'dataTypeId']
      )
    )

  // Protect
  $routeSegmentProvider
    .within('rules')
    .segment(
      'protection_rules',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/rules/protection/protection_rules.html',
        'ProtectionRuleCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'protection_rules_manage_default',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/rules/protection/manage_default.html'
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'protection_rules_drilldown',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/rules/protection/drilldown.html',
        'ProtectionRuleDrilldownCtrl',
        false,
        ['protectionRuleId']
      )
    )

  $routeSegmentProvider
    .within('rules')
    .segment(
      'cve_shield',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/rules/cve/cve_shield.html',
        'CveShieldCtrl',
        false
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'cve_shield_manage_default',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/rules/cve/manage_default.html'
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'cve_shield_drilldown',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        'views/rules/cve/drilldown.html',
        'CveShieldDrilldownCtrl',
        false,
        ['cveShieldId']
      )
    )

  const compliancePath = 'components-org/compliance-policy/'
  $routeSegmentProvider
    .within('rules')
    .segment(
      'compliance_policy',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        compliancePath + 'policy.html',
        false
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'compliance_policy_add',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        compliancePath + 'form.html',
        'ConfigureCompliancePolicyCtrl',
        false,
        ['orgUuid']
      )
    )
  $routeSegmentProvider
    .within('rules')
    .segment(
      'compliance_policy_edit',
      AuthOptionsProvider.buildSecureRouteConfigurationWithController(
        compliancePath + 'form.html',
        'ConfigureCompliancePolicyCtrl',
        false,
        ['orgUuid', 'compliancePolicyId']
      )
    )

  $routeSegmentProvider
    .when('/:orgUuid/rules', 'rules')
    .when('/:orgUuid/rules/manage', 'rules.manage')
    .when('/:orgUuid/rules/manage/default', 'rules.manage_default')
    .when('/:orgUuid/rules/manage/:ruleName', 'rules.manage_edit')
    .when('/:orgUuid/rules/controls', 'rules.controls')
    .when('/:orgUuid/rules/controls/create', 'rules.controls_add')
    .when('/:orgUuid/rules/controls/edit/:controlId', 'rules.controls_edit')
    .when(
      '/:orgUuid/rules/vulnerability-management',
      'rules.vulnerability_management'
    )
    .when(
      '/:orgUuid/rules/vulnerability-management/policy/add/:action',
      'rules.vulnerability_management_policy_add'
    )
    .when(
      '/:orgUuid/rules/vulnerability-management/policy/edit/:policyId',
      'rules.vulnerability_management_policy_edit'
    )
    .when('/:orgUuid/rules/ip', 'rules.ip')
    .when('/:orgUuid/rules/ip/denylist', 'rules.ip_denylist')
    .when('/:orgUuid/rules/ip/trusted', 'rules.ip_allowlist')
    .when('/:orgUuid/rules/ip/source-names', 'rules.ip_source_names')
    .when('/:orgUuid/rules/ip/source-names/add', 'rules.ip_source_name_add')
    .when('/:orgUuid/rules/sensitive', 'rules.sensitive')
    .when(
      '/:orgUuid/rules/ip/source-names/edit/:sourceNameId',
      'rules.ip_source_name_edit'
    )
    .when('/:orgUuid/rules/ip/add/denylist', 'rules.ip_add_denylist')
    .when(
      '/:orgUuid/rules/ip/add/denylist/:sourceIp',
      'rules.ip_add_denylist_from_attack'
    )
    .when('/:orgUuid/rules/ip/add/trusted', 'rules.ip_add_allowlist')
    .when('/:orgUuid/rules/ip/edit/:addressUuid', 'rules.ip_edit')
    .when('/:orgUuid/rules/hosts', 'rules.hosts')
    .when('/:orgUuid/rules/patches', 'rules.patch')
    .when('/:orgUuid/rules/patches/new/:eventId', 'rules.patch_from_event')
    .when('/:orgUuid/rules/patches/add', 'rules.patch_add')
    .when('/:orgUuid/rules/patches/edit/:patchUuid', 'rules.patch_edit')
    .when('/:orgUuid/rules/log', 'rules.log')
    .when('/:orgUuid/rules/log/add', 'rules.log_add')
    .when('/:orgUuid/rules/log/edit/:logId', 'rules.log_edit')
    .when('/:orgUuid/rules/sensitive', 'rules.sensitive_data_grid')
    .when(
      '/:orgUuid/rules/sensitive/edit/:dataTypeId',
      'rules.sensitive_data_type_edit'
    )
    .when('/:orgUuid/rules/library/policy', 'rules.library_policy')
    .when('/:orgUuid/rules/protection', 'rules.protection_rules')
    .when(
      '/:orgUuid/rules/protection/manage/default',
      'rules.protection_rules_manage_default'
    )
    .when(
      '/:orgUuid/rules/protection/:protectionRuleId',
      'rules.protection_rules_drilldown'
    )
    .when('/:orgUuid/rules/cve', 'rules.cve_shield')
    .when(
      '/:orgUuid/rules/cve/manage/default',
      'rules.cve_shield_manage_default'
    )
    .when('/:orgUuid/rules/cve/:cveShieldId', 'rules.cve_shield_drilldown')
    .when('/:orgUuid/rules/exclusions', 'rules.exclusions')
    .when(
      '/:orgUuid/rules/exclusions/:appId/:exclusionId',
      'rules.exclusions_edit'
    )
    .when('/:orgUuid/rules/compliance/policy', 'rules.compliance_policy')
    .when(
      '/:orgUuid/rules/compliance/policy/add',
      'rules.compliance_policy_add'
    )
    .when(
      '/:orgUuid/rules/compliance/policy/edit/:compliancePolicyId',
      'rules.compliance_policy_edit'
    )
})

// Attacks routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'attacks',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/attacks.html',
      false,
      ['orgUuid']
    )
  )
  $routeSegmentProvider
    .within('attacks')
    .segment(
      'monitor',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/attacks/monitor.html',
        true
      )
    )
  $routeSegmentProvider
    .within('attacks')
    .segment(
      'attacks',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/attacks/attacks.html'
      )
    )
  $routeSegmentProvider
    .within('attacks')
    .segment(
      'attacks_drilldown',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/attacks/attacks.html'
      ),
      false,
      ['attackId']
    )

  $routeSegmentProvider.segment(
    'attackOverview',
    AuthOptionsProvider.buildSecureRouteConfigurationWithController(
      'views/attacks/overview_attack.html',
      'AttackOverviewCtrl',
      false,
      ['orgUuid', 'attackUuid']
    )
  )

  $routeSegmentProvider
    .within('attackOverview')
    .segment(
      'summary',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/attacks/overview/summary.html',
        true
      )
    )
  $routeSegmentProvider
    .within('attackOverview')
    .segment(
      'notes',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/attacks/overview/notes.html',
        false
      )
    )
  $routeSegmentProvider
    .within('attackOverview')
    .segment(
      'discussion',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/attacks/overview/discussion.html',
        false
      )
    )

  $routeSegmentProvider
    .within('attacks')
    .segment(
      'events',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/attacks/events.html'
      )
    )

  $routeSegmentProvider
    .within('attacks')
    .segment(
      'events-light',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/attacks/events.html'
      )
    )

  $routeSegmentProvider
    .within('attacks')
    .segment(
      'events-new',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/attacks/events-new.html'
      )
    )

  $routeSegmentProvider.within('attacks').segment(
    'attackEventDrilldown',
    AuthOptionsProvider.buildSecureRouteConfigurationWithParams({
      templateUrl: 'views/attacks/attack_event_drilldown.html',
      controller: 'AttackEventDashboardCtrl',
      controllerAs: 'attackEventDashboardCtrl',
      isDefault: true,
      dependencies: ['orgUuid', 'eventId']
    })
  )

  $routeSegmentProvider
    .within('attacks')
    .segment(
      'eventsAttack',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/attacks/events.html'
      ),
      false,
      ['attackId']
    )

  $routeSegmentProvider
    .within('attacks')
    .segment(
      'eventsAttackTab',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/attacks/events.html'
      ),
      false,
      ['attackId', 'eventId', 'eventTab']
    )

  $routeSegmentProvider
    .when('/:orgUuid/attacks', 'attacks')
    .when('/:orgUuid/attacks/monitor', 'attacks.monitor')
    .when('/:orgUuid/attacks/attacks', 'attacks.attacks')
    .when('/:orgUuid/attacks/attacks/:attackId', 'attacks.attacks_drilldown')
    .when('/:orgUuid/attacks/events', 'attacks.events')
    .when('/:orgUuid/attacks/events/light', 'attacks.events-light')
    .when('/:orgUuid/attacks/events-new', 'attacks.events-new')
    .when('/:orgUuid/attacks/events/:eventId', 'attacks.attackEventDrilldown')
    .when('/:orgUuid/attacks/attacks/:attackId/events', 'attacks.eventsAttack')
    .when(
      '/:orgUuid/attacks/attacks/:attackId/events/:eventId/:eventTab',
      'attacks.eventsAttackTab'
    )
    .when('/:orgUuid/attacks/:attackUuid/overview', 'attackOverview')

    .when(
      '/:orgUuid/attacks/:attackUuid/overview/summary',
      'attackOverview.summary'
    )
    .when(
      '/:orgUuid/attacks/:attackUuid/overview/notes',
      'attackOverview.notes'
    )
    .when(
      '/:orgUuid/attacks/:attackUuid/overview/discussion',
      'attackOverview.discussion'
    )
})

// New Attack Events routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'attack-events',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/attack-events.html',
      false,
      ['orgUuid']
    )
  )

  $routeSegmentProvider.when(
    '/:orgUuid/attack-events/:attackEventId?',
    'attack-events'
  )
})

// vulnerabilities routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'vulns',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'components-org/vulnerabilities/vulns.html',
      false
    )
  )

  $routeSegmentProvider.segment(
    'vulnsFilter',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'components-org/vulnerabilities/vulns.html',
      false
    )
  )

  $routeSegmentProvider.segment(
    'vulnOverview',
    AuthOptionsProvider.buildSecureRouteConfigurationWithController(
      'components/vulnerabilities/overview.html',
      'OrgVulnOverviewCtrl',
      false,
      ['orgUuid', 'uuid']
    )
  )
  $routeSegmentProvider
    .within('vulnOverview')
    .segment(
      'summary',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/summary.html',
        true
      )
    )
  $routeSegmentProvider
    .within('vulnOverview')
    .segment(
      'recommendation',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/recommendation.html',
        false
      )
    )
  $routeSegmentProvider
    .within('vulnOverview')
    .segment(
      'request',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/request.html',
        false
      )
    )
  $routeSegmentProvider
    .within('vulnOverview')
    .segment(
      'events',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/events.html',
        false
      )
    )
  $routeSegmentProvider
    .within('vulnOverview')
    .segment(
      'notes',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/notes.html',
        false
      )
    )
  $routeSegmentProvider
    .within('vulnOverview')
    .segment(
      'discussion',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'components/vulnerabilities/discussion.html',
        false
      )
    )
  $routeSegmentProvider.segment(
    'vulnUnauthorized',
    AuthOptionsProvider.buildSecureRouteConfigurationWithController(
      'components-org/vulnerabilities/unauthorized.html',
      'OrgVulnUnauthorizedCtrl',
      false,
      ['orgUuid', 'uuid']
    )
  )

  $routeSegmentProvider
    .when('/:orgUuid/vulns', 'vulns')
    .when('/:orgUuid/vulnsFilter', 'vulnsFilter')
    .when('/:orgUuid/vulns/:uuid/overview', 'vulnOverview')
    .when('/:orgUuid/vulns/:uuid/overview/summary', 'vulnOverview.summary')
    .when(
      '/:orgUuid/vulns/:uuid/overview/recommendation',
      'vulnOverview.recommendation'
    )
    .when('/:orgUuid/vulns/:uuid/overview/request', 'vulnOverview.request')
    .when('/:orgUuid/vulns/:uuid/overview/events', 'vulnOverview.events')
    .when('/:orgUuid/vulns/:uuid/overview/notes', 'vulnOverview.notes')
    .when(
      '/:orgUuid/vulns/:uuid/overview/discussion',
      'vulnOverview.discussion'
    )
    .when('/:orgUuid/vulns/:uuid/unauthorized', 'vulnUnauthorized')
})

app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'survey',
    AuthOptionsProvider.buildSecureRouteConfigurationWithController(
      'views/survey.html',
      'SurveyCtrl',
      false,
      ['orgUuid'],
      undefined
    )
  )
  $routeSegmentProvider.when('/:orgUuid/survey', 'survey')
})

app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'newUser',
    AuthOptionsProvider.buildSecureRouteConfigurationWithController(
      'views/new-user/new-user.html',
      'newUserCtrl',
      false,
      ['orgUuid']
    )
  )
  $routeSegmentProvider
    .within('newUser')
    .segment(
      'welcome',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/new-user/welcome.html',
        true
      )
    )
  $routeSegmentProvider
    .within('newUser')
    .segment(
      'profile',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/new-user/profile.html',
        false
      )
    )

  $routeSegmentProvider
    .within('newUser')
    .segment(
      'tour',
      AuthOptionsProvider.buildSecureRouteConfiguration(
        'views/new-user/tour.html',
        false
      )
    )

  $routeSegmentProvider
    .when('/:orgUuid/newuser', 'newUser')
    .when('/:orgUuid/newuser/welcome', 'newUser.welcome')
    .when('/:orgUuid/newuser/profile', 'newUser.profile')
    .when('/:orgUuid/newuser/tour', 'newUser.tour')
})

// scm onboarding routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')

  $routeSegmentProvider.segment(
    'scm-onboarding',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/scm-onboarding.html',
      false
    )
  )

  // orgUuid is optional
  $routeSegmentProvider.segment(
    'scm-onboarding-with-org',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/scm-onboarding.html',
      false,
      ['orgUuid']
    )
  )

  $routeSegmentProvider
    .when('/scm-onboarding', 'scm-onboarding')
    .when('/:orgUuid/scm-onboarding', 'scm-onboarding-with-org')
})

app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'scm-configuration',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/scm-configuration.html'
    ),
    false,
    ['orgUuid']
  )
  $routeSegmentProvider.when('/:orgUuid/scm-configuration', 'scm-configuration')
})

// Add route for the new libraries MFE
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'libraries-mfe',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/libraries-mfe.html',
      false,
      ['orgUuid']
    )
  )

  $routeSegmentProvider.when('/:orgUuid/libraries-mfe', 'libraries-mfe')
})

// scm options routes
app.config(($routeSegmentProvider, $locationProvider, AuthOptionsProvider) => {
  'ngInject'

  $locationProvider.hashPrefix('')
  $routeSegmentProvider.segment(
    'scm-options',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/scm-options.html',
      false
    )
  )

  // orgUuid is optional
  $routeSegmentProvider.segment(
    'scm-options-with-org',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      'views/scm-options.html',
      false,
      ['orgUuid']
    )
  )
  $routeSegmentProvider
    .when('/scm-options', 'scm-options')
    .when('/:orgUuid/scm-options', 'scm-options-with-org')
})

app.config(($translateProvider, $translatePartialLoaderProvider) => {
  'ngInject'

  $translateProvider.useLoader('$translatePartialLoader', {
    urlTemplate: 'i18n/translation/{part}/{lang}.json'
  })

  // add commons parts (Strings used across different modules)
  $translatePartialLoaderProvider.addPart('commons/title')
  $translatePartialLoaderProvider.addPart('commons/detail')
  $translatePartialLoaderProvider.addPart('commons/action')
  $translatePartialLoaderProvider.addPart('commons/docs')
  $translatePartialLoaderProvider.addPart('commons/placeholder')
  $translatePartialLoaderProvider.addPart('commons/plural')
  $translatePartialLoaderProvider.addPart('commons/validation')
  $translatePartialLoaderProvider.addPart('commons/variable')
  $translatePartialLoaderProvider.addPart('commons/angular-dialog-service')

  // add shared parts (Strings shared between Oragnization and Superadmin portals
  // as shared modules and shared views: tooltips, modals, shared modules, etc.)
  $translatePartialLoaderProvider.addPart('shared/vulnerabilities')
  $translatePartialLoaderProvider.addPart('shared/account')
  $translatePartialLoaderProvider.addPart('shared/views')
  $translatePartialLoaderProvider.addPart('shared/rules')
  $translatePartialLoaderProvider.addPart('shared/libraries')
  $translatePartialLoaderProvider.addPart('shared/settings')

  // add organization modules parts
  $translatePartialLoaderProvider.addPart('organization/notifications')
  $translatePartialLoaderProvider.addPart('organization/rules')
  $translatePartialLoaderProvider.addPart('organization/sensitive-data')
  $translatePartialLoaderProvider.addPart('organization/account')
  $translatePartialLoaderProvider.addPart('organization/settings')
  $translatePartialLoaderProvider.addPart(
    'organization/settings/organization-applications-settings-form'
  )
  $translatePartialLoaderProvider.addPart('organization/reports')
  $translatePartialLoaderProvider.addPart('organization/home')
  $translatePartialLoaderProvider.addPart('organization/libraries')
  $translatePartialLoaderProvider.addPart('organization/wizard')
  $translatePartialLoaderProvider.addPart('organization/servers')
  $translatePartialLoaderProvider.addPart('organization/applications')
  $translatePartialLoaderProvider.addPart('organization/tsv')
  $translatePartialLoaderProvider.addPart('organization/dashboard')
  $translatePartialLoaderProvider.addPart('organization/vulnerabilities')
  $translatePartialLoaderProvider.addPart('organization/attacks')
  $translatePartialLoaderProvider.addPart('organization/attack-events')
  $translatePartialLoaderProvider.addPart('organization/attack-event-examples')
  $translatePartialLoaderProvider.addPart('organization/onboarding')
  $translatePartialLoaderProvider.addPart('organization/value-reporting')
  $translatePartialLoaderProvider.addPart('organization/add-sensor-wizard')
  $translatePartialLoaderProvider.addPart('organization/scm-onboarding')
  $translatePartialLoaderProvider.addPart('organization/scm-options')

  // general i18n configuration
  $translateProvider.preferredLanguage('en')
  $translateProvider.fallbackLanguage('en')
  $translateProvider.useSanitizeValueStrategy('escapeParameters')
  $translateProvider.addInterpolation('$translateMessageFormatInterpolation') // support pluralization
})

app.config(($httpProvider) => {
  'ngInject'

  $httpProvider.interceptors.push('securityInterceptor')
  $httpProvider.interceptors.push('excludeLinksInterceptor')
  $httpProvider.interceptors.push('sessionTimeoutInterceptor')
})

app.config((toastrConfig) => {
  'ngInject'

  angular.extend(toastrConfig, {
    closeButton: true,
    positionClass: 'toast-top-center',
    progressBar: true,
    closeHtml: '<i cs-icon="close"></i>',
    maxOpened: 1,
    preventOpenDuplicates: false,
    timeOut: 2500,
    newestOnTop: true
  })
})

app.config(($uibTooltipProvider) => {
  'ngInject'

  $uibTooltipProvider.setTriggers({ hoverableOpen: 'hoverableClose' })
})

app.config((msdElasticConfig) => {
  'ngInject'

  // angular-elastic textarea dynamic resize config
  msdElasticConfig.append = '\n'
})

// @ts-ignore
app.run(run)

export function run(
  $log: angular.ILogService,
  $window,
  $route,
  $location,
  permissions,
  editableOptions,
  featureFlags,
  featureFlagOverrides,
  $rootScope,
  FeaturesService,
  AuthFactory,
  AuthService,
  UserService,
  ProfileService,
  GoogleAnalyticsService,
  $uibModalStack,
  CommonFactory,
  AUTH_EVENTS,
  FEATURE_FLAGS_LOADED_EVENT,
  ADMIN_PORTAL_URL,
  URLHistoryService
) {
  'ngInject'

  global.CONTRAST.Performance.mark('ng.appRun')

  $rootScope.$on('profile:loaded', () => {
    datadogRum.setUser({
      id: ProfileService.getId(),
      // check with legal if we're allowed to send the user name and email
      // email: ProfileService.getEmail(),
      name: ProfileService.getId() //ProfileService.getName()
    })
  })

  // No reason to destroy $rootScope event listeners in the run block, because they last for the life of the app
  $rootScope.$on(AUTH_EVENTS.AUTHENTICATED_TRUE, () => {
    if (
      process.env.LOCAL_DATADOG_RUM &&
      window.location.hostname === 'localhost' &&
      !$window.contrast_env_config
    ) {
      $log.debug('Setting up localhost datadog RUM config')
      $window.contrast_env_config = {
        env: 'localhost',
        version: 'localhost-version'
      }
    }

    if (
      $window.contrast_env_config &&
      isEmpty(datadogRum.getInitConfiguration())
    ) {
      $log.debug('Initializing datadog RUM')

      datadogRum.init({
        clientToken: 'pubea7a0c730cab2ae9a2b9291e2f9aa1c4',
        applicationId: 'c3d55893-ffbe-4050-9e4f-39bfae395050',
        site: 'datadoghq.com',
        service: 'contrast-ui',
        sessionSampleRate: 100,
        traceSampleRate: 100,
        trackUserInteractions: true,
        trackViewsManually: true,
        sessionReplaySampleRate: 100,
        defaultPrivacyLevel: 'mask',
        enableExperimentalFeatures: ['feature_flags'],
        ...$window.contrast_env_config
      })
    }

    FeaturesService.loadFeatureFlags().then((flagsPromise) => {
      if (flagsPromise !== null) {
        return featureFlags
          .set(flagsPromise)
          .then(FeaturesService.loadAgentFeatures)
          .then(() => {
            $rootScope.$broadcast(FEATURE_FLAGS_LOADED_EVENT)
          })
      } else {
        $rootScope.$broadcast(FEATURE_FLAGS_LOADED_EVENT)
      }
    })
  })

  $rootScope.$on(AUTH_EVENTS.UNAUTHENTICATED_EVENT, featureFlagOverrides.reset)

  editableOptions.theme = 'bs3' // bootstrap3 theme. Can be also 'bs2', 'default'

  // http://joelsaupe.com/programming/angularjs-change-path-without-reloading/
  const original = $location.path
  // @ts-ignore
  $location.path = (path, reload) => {
    if (reload === false) {
      const lastRoute = $route.current
      const deregister = $rootScope.$on('$locationChangeSuccess', () => {
        $route.current = lastRoute
        deregister()
      })
    }
    return original.apply($location, [path])
  }

  $rootScope.$on('$routeChangeStart', (_, current) => {
    let viewName = current.originalPath
    // assist datadog in distinguishing between the routes with and without optional parameters such as attackEventId
    // this logic can be made generic, but not worth the effort right now since we only have one use case
    if (current.originalPath === '/:orgUuid/attack-events/:attackEventId?') {
      viewName = current.pathParams.attackEventId
        ? '/:orgUuid/attack-events/:attackEventId'
        : '/:orgUuid/attack-events'
    }

    GoogleAnalyticsService.sendPageView(current)
    datadogRum.startView({
      name: viewName
    })

    global.CONTRAST.Performance.mark('ng.routeChangeStart')

    if (current.segment === 'pages/signin') {
      $uibModalStack.dismissAll('Unauthorized')
      const queryParams = $location.search() || {}
      if (!queryParams.unauthenticated) {
        // check for active session for superadmin user.
        // If session does not exist. Check for org user.
        // OtHeRwIse Do NoT aUth
        AuthFactory.isUserActive(true)
          .then(() => {
            // Redirect to superadmin
            $window.location.href = ADMIN_PORTAL_URL
          })
          .catch(() => {
            // check user active
            return AuthFactory.isUserActive(false).then(() => {
              // org user is active
              AuthService.setAuthenticated(true)
              if (UserService.isLoaded()) {
                const previousUrl = URLHistoryService.getPreviousUrl()
                if (previousUrl) {
                  URLHistoryService.redirectToNewUiOrPreviousUrl(
                    previousUrl,
                    true
                  )
                } else {
                  // @ts-ignore
                  $location.path(UserService.buildUrl('/dashboard'), true)
                }
              } else {
                permissions
                  .getDefaultOrganization()
                  .then(() => {
                    const previousUrl = URLHistoryService.getPreviousUrl()
                    if (previousUrl) {
                      URLHistoryService.redirectToNewUiOrPreviousUrl(
                        previousUrl,
                        true
                      )
                    } else {
                      // @ts-ignore
                      $location.path(UserService.buildUrl('/dashboard'), true)
                    }
                  })
                  .catch($log.error)
              }
              permissions.loadUserSettings(true).catch($log.error)
            })
          })
          .catch(() => {
            $log.warn('org user is not active')
            AuthService.setAuthenticated(false)
            CommonFactory.getInformation().then((response) => {
              if (response.data.http_authentication_enabled) {
                $window.location.href =
                  '/Contrast/static/ng/index.html#/pages/401'
              }
            })
          })
      }
    }
  })

  $rootScope.$on(
    '$routeChangeError',
    (_event, _current, _previous, eventObj) => {
      if (eventObj.authenticated === false) {
        $rootScope.$broadcast(AUTH_EVENTS.UNAUTHENTICATED_EVENT)
        // @ts-ignore
        $location.path('/pages/signin', true).search('routeError', 'true')
      }
    }
  )

  $rootScope.$on('routeSegmentChange', (_, route) => {
    onRouteSegmentChange({
      route,
      Performance: global.CONTRAST.Performance,
      $window,
      permissions,
      FeaturesService
    })
  })
}

export function canAccessEACUsersPage($q, FeaturesService, $location) {
  'ngInject'
  const rbacStatus = FeaturesService.getRbacStatus()
  if (rbacStatus.enabled && rbacStatus.isEnforced) {
    $location.path('/' + $location.path().split('/')[1] + '/settings/access')
    return $q.reject()
  }

  return $q.resolve()
}

export function onRouteSegmentChange({
  route,
  Performance,
  $window,
  permissions,
  FeaturesService
}: {
  readonly route?: {
    readonly segment?: {
      readonly name: string
      readonly params?: {
        readonly template?: string
      }
    }
  }
  readonly Performance: any
  readonly $window: any
  readonly permissions: any
  readonly FeaturesService: any
}) {
  // TS-31437 - Reject non-admins from accessing if the feature flag is on
  if (
    route?.segment?.name === 'projects' &&
    route.segment.params?.template === '' &&
    FeaturesService.isSplitFeatureFlagOn(
      'PROD-2918_hide_sca_data_unless_org_admin'
    ) &&
    !permissions.hasPermission('ADMIN')
  ) {
    $window.location.href = '/Contrast/static/ng/index.html#/pages/401'
  }

  if (
    route &&
    route.segment &&
    route.segment.params &&
    route.segment.params.template !== ''
  ) {
    Performance.measure({
      category: 'loading',
      name: 'ng.routeChange.' + route.segment.name,
      startMark: 'ng.routeChangeStart'
    })

    Performance.measure(
      {
        category: 'loading',
        name: 'ng.firstRouteLoaded',
        startMark: 'ng.appRun'
      },
      { limit: true }
    )
  }
}
